import { ConditionalText } from '@shared/components'
import { Badge } from 'antd'

type Props = {
  text?: string
  color?: string | null
}

export const BadgeText = ({ text, color }: Props) => {
  return color ? (
    <Badge color={color} text={text} />
  ) : (
    <ConditionalText weight={400} condition={!!text}>
      {text}
    </ConditionalText>
  )
}
